import { useState, useEffect, } from 'react';

import { Box, Typography, Button, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import Popup from '../Popup.jsx';

import { getBillingItems, updateBillingItem, deleteBillingItem } from '../../api/billingItems.js'

import { ModelBillingItem } from '../../models/ModelBillingItem.js';
import { generateId } from '../../scripts/utils.js';
import { Currencies, Units, TaxRates } from '../../scripts/configData.js';

import { useData } from '../../hooks/DataProvider.jsx';
import translations from '../../scripts/translations.json';
import { CreatFieldComponent } from '../Fields.jsx';


const SelectedItem = ({ activeItem, updateActiveItem, handleSave, handleDelete }) => {

    const { language } = useData();
    const btns = translations.button[language];
    const page = translations.components.billingItems[language];



    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 2, }}>
            <Box
                sx={{ display: 'grid', gridTemplateColumns: '.5fr 1.5fr 1.5fr 1fr 1fr  1fr', gap: 1, width: '100%' }}
            >
                <CreatFieldComponent field={ModelBillingItem.code} data={activeItem} updateData={updateActiveItem} />
                <CreatFieldComponent field={ModelBillingItem.designationFr} data={activeItem} updateData={updateActiveItem} />
                <CreatFieldComponent field={ModelBillingItem.designationEn} data={activeItem} updateData={updateActiveItem} />
                <CreatFieldComponent field={ModelBillingItem.categoryA} data={activeItem} updateData={updateActiveItem} />
                <CreatFieldComponent field={ModelBillingItem.categoryB} data={activeItem} updateData={updateActiveItem} />
                <CreatFieldComponent field={ModelBillingItem.categoryC} data={activeItem} updateData={updateActiveItem} />
            </Box>
            <Box
                sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr', gap: 1, width: '100%' }}
            >

                <CreatFieldComponent field={ModelBillingItem.unit} data={activeItem} updateData={updateActiveItem} options={Units} />
                <CreatFieldComponent field={ModelBillingItem.quantity} data={activeItem} updateData={updateActiveItem} />
                <CreatFieldComponent field={ModelBillingItem.unitPrice} data={activeItem} updateData={updateActiveItem} />
                <CreatFieldComponent field={ModelBillingItem.unitPriceMin} data={activeItem} updateData={updateActiveItem} />
                <CreatFieldComponent field={ModelBillingItem.unitPriceMax} data={activeItem} updateData={updateActiveItem} />
                <CreatFieldComponent field={ModelBillingItem.taxRate} data={activeItem} updateData={updateActiveItem} options={TaxRates} />
                <CreatFieldComponent field={ModelBillingItem.currency} data={activeItem} updateData={updateActiveItem} options={Currencies} />
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}  >
                <Typography variant='overline' color='#00000099' >{page.memo} :</Typography>

                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 1, width: '100%' }}  >
                    <CreatFieldComponent field={ModelBillingItem.memo} data={activeItem} updateData={updateActiveItem} />
                </Box>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexGrow: 1 }}>
                    <Button variant='outlined' size='small' onClick={() => updateActiveItem({})} > <CloseIcon /> </Button>
                    <Button variant='outlined' size='small' onClick={handleSave} > {btns.save} </Button>
                </Box>

                <Button variant='outlined' size='small' onClick={() => handleDelete(activeItem._id)} > <DeleteOutlineIcon /> </Button>
            </Box>
        </Box>
    );
}



const BillingItems = () => {

    const { language } = useData();
    // const btns = translations.button[language];
    const page = translations.components.billingItems[language];

    const [items, setItems] = useState([]);
    const [activeItem, setActiveItem] = useState({});
    const [popupData, setPopupData] = useState({
        open: false,
        code: null,
        id: null,
        fn: null,
    });

    const [updateId, setUpdateId] = useState(0);

    const incrementUpdateId = () => {
        setUpdateId(prevId => prevId + 1);
    }

    const updateActiveItem = (data) => {
        setActiveItem(data);

    }

    const handleSave = async () => {

        let isCurrentItem = false;

        for (let i in items) {
            if (items[i].code === activeItem.code && items[i]._id !== activeItem._id) {
                isCurrentItem = true;
                break;
            }
        }

        if (isCurrentItem) {

            setPopupData({
                open: true,
                code: 'articleCodeExistsWarning',
                id: activeItem.code,
                fn: (id) => { setPopupData({ open: false, code: null, id: null, fn: null }); },
                types: {
                    hasCancel: true,
                    hasConfirm: false,
                }
            });

            const NewItems = items.filter(item => item._id !== activeItem._id);
            setItems([...NewItems]);

            return;

        } else {
            const updatedItem = await updateBillingItem(activeItem);
            if (updatedItem) {

                let itemsCopy = [];
                for (let i = 0; i < items.length; i++) {
                    if (items[i]._id === activeItem._id) {
                        itemsCopy.push(updatedItem);
                    } else {
                        itemsCopy.push(items[i]);
                    }
                }

                setItems([...itemsCopy]);
                setActiveItem({});
            }
            incrementUpdateId()
        }
    }

    const hendelAdd = () => {
        const newItem = {
            _id: generateId(),
            code: '',
            categoryA: '',
            categoryB: '',
            categoryC: '',
            unit: null,
            quantity: 0,
            unitPrice: 0,
            unitPriceMin: null,
            unitPriceMax: null,
            taxRate: null,
            currency: Currencies[0].key,
            memo: '',
        }
        setActiveItem(newItem);
        setItems([...items, newItem]);

    }

    const handleDelete = async (id) => {

        const result = await deleteBillingItem(id);
        if (result) {
            setItems(items.filter(item => item._id !== id));
            if (activeItem._id === id) {
                setActiveItem({});
            }
        }
    }

    const handelDeletePopup = (id) => {
        setPopupData({
            open: true,
            code: 'deleteBillingArticleConfirmation',
            id: id,
            fn: handleDelete,
            types: {
                hasCancel: true,
                hasConfirm: true,
            }
        });
    }


    useEffect(() => {
        const fetchData = async () => {
            const data = await getBillingItems();
            if (data) {
                data.sort((a, b) => a.code.localeCompare(b.code));
                setItems(data);
            }
        };
        fetchData();
    }, [updateId]);


    return (
        <>
            {!activeItem?._id && <><Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant='h6' sx={{ mb: 2 }}>{page.title}</Typography>
                <Button variant='outlined' onClick={hendelAdd} size='small'> <AddIcon /> </Button>
            </Box>
                <Box sx={{ gap: 1 }}>
                    {items.map((item) => (
                        <Box key={item._id} sx={{ border: '1px solid #ccc', marginBottom: 2, borderRadius: 1, p: .5, cursor: 'pointer', direction: 'row', display: 'flex', gap: 2, alignItems: 'center' }}
                            onClick={() => setActiveItem(item)}
                        >
                            <Typography variant="subtitle1">{item?.code}</Typography>
                            {language === 'fr' ? 
                                <Typography variant="subtitle1">{item?.designationFr}</Typography> 
                                :
                                <Typography variant="subtitle1">{item?.designationEn}</Typography>}
                            <Typography variant="subtitle1">{item?.categoryA}</Typography>
                            <Typography variant="subtitle1">{item?.categoryB}</Typography>
                            <Typography variant="subtitle1">{item?.categoryC}</Typography>
                            <Typography variant="subtitle1">{item?.unit}</Typography>
                            <Typography variant="subtitle1">{item?.unitPrice}</Typography>
                        </Box>))
                    }
                </Box></>}
            {activeItem?._id && <SelectedItem activeItem={activeItem} updateActiveItem={updateActiveItem} handleSave={handleSave} handleDelete={handelDeletePopup} />}
            {popupData.open && <Popup popupData={popupData} setPopupData={setPopupData} />}

        </>
    )



}



export default BillingItems;